const initialTasks = {
  Plan: [
    { id: "1", title: "Identify improvement area", owner: "Alice" },
    { id: "2", title: "Gather baseline data", owner: "Bob" },
    { id: "6", title: "Define project scope", owner: "Charlie" },
  ],
  Do: [
    { id: "3", title: "Implement solution", owner: "Charlie" },
    { id: "7", title: "Train team members", owner: "Dana" },
  ],
  Check: [
    { id: "4", title: "Review performance metrics", owner: "Dana" },
    { id: "8", title: "Analyze test results", owner: "Eve" },
  ],
  Act: [
    { id: "5", title: "Standardize successful processes", owner: "Eve" },
    { id: "9", title: "Document lessons learned", owner: "Alice" },
  ],
};

export default initialTasks;
